import builder from '../builder';
import TouchIdApproved from '../../streamline-icons/light/touch-id-approved-1.svg';

export default builder('IconTouchIdApprovedLight', TouchIdApproved);
